<template>

  <div class="container-fluid">
    <!--<div class="row" style="padding-top: 1em">-->
    <hr>
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2" for="name">{{$t('pages.adminpanel.year.editName')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="save" type="text" id='name' class="form-control" v-model="year_name">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="requiredFields">{{$t('pages.adminpanel.year.editRequiredFields')}}:</label>
        <div class="col-sm-10">
          <form id="requiredFields">
            <label class="checkbox-inline" v-for="(field, id) in possibleRequiredFields">
              <input type="checkbox" v-model="field.checked">{{$t('pages.requiredField.' + field.name)}}
            </label>
          </form>
          <!--<input @keyup.enter="save" type="text" id='requiredFields' class="form-control" v-model="year_name">-->
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.adminpanel.year.archived')}}:</label>
        <div class="col-sm-10">
          <form>
            <label class="checkbox-inline">
              <input v-model="isArchived" type="checkbox"> {{$t('pages.adminpanel.year.archived')}}
            </label>
          </form>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button v-if="!isReadOnly" @click.prevent.stop="save" class="btn btn-app pull-right">
            <i class="fa fa-save"></i>{{Save}}
          </button>
          <button v-if="year.id != ''" class="btn btn-danger pull-left" @click.prevent.stop="deleteYear()">
            <i class="fa fa-trash"></i>
          </button>
        </div>
        <div class="col-sm-offset-2 col-sm-10">
          <div class="pull-right">
            <a class="btn btn-box-tool" @click.prevent.stop="closeDropdown()">
              <i class="fa fa-caret-up"></i>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
  // import Vue from 'vue'
  import Rest from './../../services/rest'
  import { mapState } from 'vuex'
  // import router from './../../router/router'
  export default {
    data () {
      return {
        isReadOnly: false,
        groupList: '',
        Edit: this.$t('pages.buttons.edit'),
        Save: this.$t('pages.buttons.save'),
        isArchived: false,
        possibleRequiredFields: [
          {name: 'firstName'},
          {name: 'lastName'},
          {name: 'studentId'},
          {name: 'allowUseOfMyResults'},
          {name: 'username'},
          {name: 'profilePictureUrl'}]
      }
    },
    props: {
      year: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        // year: state => state.selectedYear
      }),
      year_name: {
        get () {
          return this.year.yearName
        },
        set (value) {
          this.year.yearName = value
          // this.$store.commit('updateYearObj', {
          //   key: 'name',
          //   value: value
          // })
        }
      },
      year_visible: {
        get () {
          return this.year.isArchived
        },
        set (value) {
          this.$store.commit('updateYearObj', {
            key: 'visible',
            value: value
          })
        }
      }
    },
    methods: {
      save: function () {
        this.isReadOnly = true
        var requiredFields = []
        for (var i in this.possibleRequiredFields) {
          if (this.possibleRequiredFields[i].checked) {
            requiredFields.push(this.possibleRequiredFields[i].name)
          }
        }
        var postdata = {
          id: this.year.yearId,
          name: this.year.yearName,
          visible: !this.isArchived,
          requiredFields: requiredFields
        }
        return Rest.request('PUT', '/years/' + this.year.yearId, postdata).then((data) => {
          this.$store.commit('updateYearObj', {
            key: 'requiredFields',
            value: requiredFields
          })
          this.Edit = this.$t('pages.buttons.success')
          this.$set(this.year, 'showEditYear', !this.year.showEditYear)
          this.$store.dispatch('getGroupsNew')
          this.$store.dispatch('getAllGroups')
          // this.$store.state.adminpanel.colapseEditYear = !this.$store.state.adminpanel.colapseEditYear // if success colapse
        }).catch((err) => {
          console.log(err)
          this.Edit = this.$t('pages.buttons.fail')
        })
      },
      deleteYear: function () {
        var answer = confirm('Are you sure?')
        if (answer) {
          return Rest.request('DELETE', '/years/' + this.year.yearId).then((data) => {
            this.yearName = ''
            this.$store.dispatch('getGroupsNew')
            this.year.showEditYear = false
            // this.$store.state.adminpanel.colapseEditYear = !this.$store.state.adminpanel.colapseEditYear // if success colapse
          }).catch((err) => {
            console.log(err)
            this.Edit = 'Failed'
          })
        }
      },
      closeDropdown () {
        if (this.isPanel) this.$store.commit('toggleEditYear')
        else this.$set(this.year, 'showEditYear', !this.year.showEditYear)
      }
    },
    created () {
      this.isArchived = this.year.isArchived
      for (let i = 0; i < this.possibleRequiredFields.length; i++) {
        if (this.year.requiredFields.includes(this.possibleRequiredFields[i].name)) {
          this.possibleRequiredFields[i].checked = true
        } else {
          this.possibleRequiredFields[i].checked = false
        }
      }
    }
  }
</script>

<style scoped>

  /*<!-- SASS styling -->*/
  /*<style lang="scss">*/
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #f1eff7; /* ali lightcyan*/
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>



// WEBPACK FOOTER //
// EditYear.vue?0abd7980